require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./kriterien-schliesstage-geschl-jahr-3-6-j-2018-19.json") })
        }
      }, "path---kriterien-schliesstage-geschl-jahr-3-6-j-2018-19");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---kriterien-schliesstage-geschl-jahr-3-6-j-2018-19!./.cache/json/kriterien-schliesstage-geschl-jahr-3-6-j-2018-19.json
// module id = 1098
// module chunks = 231608221292675